import { isEmpty } from 'lodash-es';
const WEATHER_MAP_INCOMPATIBLE_METRICS = [
    'U_CAPA',
    'HPOT',
    'LW_D',
    'T_WET',
    'T_SOIL',
    'CAPA',
    'LW_V',
    'PPFD',
    'PPFD_MAX',
    'PPFD_MIN',
    'SSI_MIN',
    'SSI_MAX',
    'T_CAL',
    'T_CAPA',
    'T_DEW'
];
function canBeOnWeatherMap(device) {
    return (!isEmpty(device.availableMeasures) &&
        !device.availableMeasures.some((m) => WEATHER_MAP_INCOMPATIBLE_METRICS.includes(m)));
}
export default canBeOnWeatherMap;
